import { gql } from '@apollo/client';

export const GENERATE_SLIDESHOW_IA = gql`
  mutation GenerateSlideshowIA(
    $recipeNumber: Int!
    $slideshowSubject: NonEmptyString!
    $brandKey: BrandKey!
    $recipeIds: [String!]!
  ) {
    generateAISlideshow(
      brandKey: $brandKey
      recipeNumber: $recipeNumber
      slideshowSubject: $slideshowSubject
      recipeIds: $recipeIds
    ) {
      status
    }
  }
`;
